import { createSlice } from '@reduxjs/toolkit';

const MAX_ENTRIES = 100;

const initialState = {
  entries: [],
};

const apiHistorySlice = createSlice({
  name: 'apiHistory',
  initialState,
  reducers: {
    addApiCall: (state, action) => {
      const entry = {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        timestamp: new Date().toISOString(),
        time: new Date().toLocaleTimeString(),
        ...action.payload,
      };
      state.entries.unshift(entry);
      if (state.entries.length > MAX_ENTRIES) {
        state.entries.pop();
      }
    },
    clearApiHistory: (state) => {
      state.entries = [];
    },
  },
});

export const { addApiCall, clearApiHistory } = apiHistorySlice.actions;
export default apiHistorySlice.reducer;
